export const stripeCustomerUrl = 'https://dashboard.stripe.com/customers/';
export const clarionDoorURL = 'https://gobranch.insuredapp.com/rating/prod-requests/';
